import ravitejaalchuri from '../assets/png/ravi_teja_alchuri.png'
import mobineantony from '../assets/png/mobine_antony.png'

export const recommendationsData = [
    {
        id: 1,
        name: 'Ravi Teja Alchuri',
        title: 'Technology Director',
        url: 'https://www.linkedin.com/in/ravi-teja-alchuri/',
        text: "I pursued my Master's at UTA alongside Teja, where his dedication, focus, and eagerness to learn stood out. His disciplined approach and positive attitude make him an asset to any team.",
        image: ravitejaalchuri
    },
    {
        id: 2,
        name: 'Mobine Antony',
        title: 'Quality Engineering Lead',
        url: 'https://www.linkedin.com/in/mobine-antony-68618374/',
        text: `I met Sai a couple of years ago at a coffee shop in Austin. He had his head down in a project, we struck up a conversation, and I came away impressed by the way he thinks. He isn't someone who settles for the surface answer. He wants to know how things really work, and why.\n\nWe've kept in touch since then, and watching him grow has been genuinely rewarding. He's taken that same curiosity and turned it into real ability. What stands out most is how committed he is to getting better. He takes his work seriously, and it shows.\n\nSai is sharp, driven, and a pleasure to know. I think he has a strong career ahead of him, and any team would be fortunate to have him.`,
        image: mobineantony
    }
]
